import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { NdtHubBase } from '../base/ndt-hub.base';
import { NdtHubConnectionService } from '../ndt-hub-connection.service';
import { e911Changed } from './e911-hub.actions';

@Injectable({ providedIn: 'root' })
export class E911Hub extends NdtHubBase {
   constructor(public ndtHubService: NdtHubConnectionService, private store: Store) {
      super(ndtHubService);
   }

   registerAsE911(locationId: number): void {
      this.ndtHubService.connected.subscribe(() => {
         this.ndtHubService.connection.invoke('JoinE911Group', locationId);
      });
   }

   wireUpHubEvents(): void {
      this.ndtHubService.connection.on('E911Changed', () => {
         this.store.dispatch(e911Changed());
      });
   }
}
